define([
    "./monitoringConfigurationModule",
    "./monitoringVelocityConfigurationModal"
], function () {
});